import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  name: yup.object().shape({
    displayName: yup.string().required('Display name is required.'),
    printName: yup.string().required('Print name is required.'),
  }),
  price: yup
    .number()
    .required('Price is required.')
    .moreThan(-1, `Price can't be negative.`)
    .typeError('Enter valid amount.'),
  description: yup.string().required('Description is required.'),
  printDescription: yup.string(),
});

export default validationSchema;
